import { render } from "./CompanyInvestments.vue?vue&type=template&id=01abda08"
import script from "./CompanyInvestments.vue?vue&type=script&lang=js"
export * from "./CompanyInvestments.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__